module.exports = __webpack_public_path__ + "static/button-icon2x-cee28bc16aeaa459cc7a28523c7f31fc.png";